// extracted by mini-css-extract-plugin
module.exports =  {"checker":"checker--QDfmF","col":"col--Ua1SE","item":"item--sdTI6","active":"active--c_q3v","vertical":"vertical--NevRz"};